module.exports = require('./helpers/bundle-url').getBundleURL('2c9kW') + "../fonts/pbf/Flama Medium/33024-33279.pbf";